import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table, Badge } from "reactstrap";
import { toast } from "react-toastify";
import httpService from "../../services/httpService";

export default function OrganizationsList() {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    httpService
      .get("organizations")
      .then(({ data }) => setOrganizations(data))
      .catch(() => toast.error("Failed to load organizations"))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  if (loading) return <div className="container mt-3">Loading...</div>;

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Organizations</h2>
        <Link to="/organizations/new">
          <Button color="primary">Create New</Button>
        </Link>
      </div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Domain</th>
            <th>Email Template</th>
            <th>Active</th>
            <th>Members</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          {organizations.map((org) => (
            <tr key={org.id}>
              <td>
                <Link to={`/organizations/${org.id}`}>{org.name}</Link>
              </td>
              <td>{org.domain || "—"}</td>
              <td>{org.emailTemplate || "—"}</td>
              <td>
                {org.isActive ? (
                  <Badge color="success">Active</Badge>
                ) : (
                  <Badge color="secondary">Inactive</Badge>
                )}
              </td>
              <td>{org.memberCount}</td>
              <td>{formatDate(org.createDate)}</td>
            </tr>
          ))}
          {organizations.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center">
                No organizations found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}
